import React from 'react';
import { observer, inject } from 'mobx-react';

import { Loader } from '@smartplatform/ui';
import Question from './Question';

@inject('store') @observer
export default class Questions extends React.Component {

	render() {
		const { session, importInProgress } = this.props.store;
		
		const allQuestions = session.questions();
		const agenda = allQuestions.find(question => question.code === 'agenda');
		const procedural = allQuestions.find(question => question.code === 'procedural');
		const questions = allQuestions.filter(question => question.code === 'question');
		
		return <div className="questions block">
			{importInProgress && <div style={{ marginBottom: 10 }}><Loader size={18} /></div>}
			{agenda && <Question key={agenda.id} question={agenda} />}
			{procedural && <Question key={procedural.id} question={procedural} />}
			{questions.map(question => <Question key={question.id} question={question} />)}
		</div>;
	}
}

